<nz-page-header>
  <nz-page-header-title>
    <i class="fal fa-box-full"></i>

    {{'Catalogs' | translate}}
  </nz-page-header-title>
  <nz-page-header-extra>
    <nz-space nzSize="large">

      <ng-container *nzSpaceItem>
        <button *isAuthorized="'Admin'" nz-button nzType="primary" [routerLink]="['/product-catalog/manage-catalog']">
          <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
         {{'Create New Catalog' | translate}}
        </button>
      </ng-container>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>



<!-- Header  -->
<div class="header-container">
  <div class="search-container">
    <nz-input-group nzSearch [nzSuffix]="suffixButton">
      <input type="text" [(ngModel)]="searchValue" nz-input [placeholder]="'Search...' | translate" (ngModelChange)="onSearch()" />
    </nz-input-group>

    <ng-template #suffixButton>
      <button (click)="onSearch()" nz-button nzType="default" nzSearch>
        <i class="fas fa-search"></i>

      </button>
    </ng-template>

  </div>
</div>





<div class="main-container">
  <!-- <div class="filter-sidebar">
    <div class="form-wrapper">
      <div class="filter-container">
        <h4 style="font-weight: bold;font-size: 20px;">Filters</h4>
        <nz-divider></nz-divider>
        <nz-input-group>
          <input type="text" nz-input placeholder="input search text" />
        </nz-input-group>
        <div class="category-dropdown">
    
          <nz-collapse nzGhost class="collapse-checkbox-group">
            <nz-collapse-panel [nzHeader]="'Category 1'" [nzActive]="true" [nzDisabled]="false">
              <div class="collapse-content">

                <label *ngFor="let checkbox of checkboxes" nz-checkbox [(ngModel)]="checkbox.label"
                  (ngModelChange)="onCheckboxChange($event, checkbox.label)" class="ant-checkbox-group-item">
                  {{ checkbox.label }}
                </label>
              </div>
            </nz-collapse-panel>
          </nz-collapse>


        </div>


        <div class="category-dropdown">
       

          <nz-collapse nzGhost class="collapse-checkbox-group">
            <nz-collapse-panel [nzHeader]="'Category 1'" [nzActive]="true" [nzDisabled]="false">
              <div class="collapse-content">

                <label *ngFor="let checkbox of checkboxes" nz-checkbox [(ngModel)]="checkbox.label"
                  (ngModelChange)="onCheckboxChange($event, checkbox.label)" class="ant-checkbox-group-item">
                  {{ checkbox.label }}
                </label>
              </div>
            </nz-collapse-panel>
          </nz-collapse>


        </div>
        
      </div>
    </div>
  </div> -->

  <div class="catalog-container">

    <div>
      <nz-spin 
        *ngIf="isLoading"
        nzSize="large">
      </nz-spin>
    </div>
    

    <div class="custom-table" *ngIf="!isLoading">
      <nz-table [nzData]="displayedCatalog" nzTableLayout="fixed" [nzBordered]="true" [nzShowPagination]="true"
        [nzShowSizeChanger]="true" [nzTotal]="displayedCatalog.length" [nzPageIndex]="catalogTableParams.index"
        [nzPageSize]="catalogTableParams.size" (nzPageIndexChange)="onPageChange($event)" #catalogsTable>
        <thead>
          <tr style="height: 100px;">
            <th [nzSelections]="listOfSelection" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
               nzWidth="50px"></th>
            <th nzWidth="150px"  >{{'Image' | translate}}</th>
            <th style="width: 200px;">{{'Name' | translate}}</th>
            <th>description</th>

         
            <th nzWidth="75px">{{'URL' | translate}}</th>
            <th nzWidth="6%">{{'Actions' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let catalog of catalogsTable.data">
            <td [nzChecked]="checked"></td>
            <td style="height: 100px;" 
            (click)="goToEditCatalog(catalog)">
              <!-- <img
              [src]="catalogImages.get(catalog.id!)?.bannerUrl ? catalogImages.get(catalog.id!)?.bannerUrl : '../../../assets/defaultProductImage.png' "
                alt="image" class="catalog-table-image"> -->
                <img
                *ngIf="catalog.id !== undefined"
                [src]="catalogImages.get(catalog.id) || 'assets/defaultProductImage.png'"
                alt="Catalog Image"
                class="catalog-table-image"
              />
              
            </td>
       
          
            

            <td  (click)="goToEditCatalog(catalog)">{{ catalog.name }}</td>
            <td>{{ catalog.description }}</td>

            <!-- <td style="text-align: center;">
              <nz-tag nzColor="green">Active</nz-tag>
            </td> -->
            <td style="text-align: center;">
     
              <span nz-icon [nzType]="isCopied[catalog.id!] ? 'check' : 'copy'" nzTheme="outline" class="action-icon"
                [ngClass]="{'is-copied': isCopied[catalog.id!]}"
                (click)="copyToClipboard(catalog.id!,catalog.catalogCode,catalog.name)"></span>

            </td>
            <td style="text-align: center;">
              <ng-container *isAuthorized="'Admin,Editor'">
                <button nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'" style="border:none;font-size: 20px;background: none;
                      display: flex;  align-items: center;
                      justify-content: center;
                      width:40px;
                      align-items: center;">
                  <div class="horizontal-dots" style="margin-left: 20px;">
                    <span></span>
                  </div>

                </button>

                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu class="dropdown-menu">

                    <li nz-menu-item>
                      <a nz-button nzType="text" target="_blank"
                         [routerLink]="['/product-catalog/catalog-cards', catalog.id, catalog.catalogCode]"
                         [queryParams]="{ catalogName: catalog.name }"
                         style="background: none;">
                        <span nz-icon nzType="eye" nzTheme="outline"></span> {{'Preview' | translate}}
                      </a>
                    </li>
                    
                    <li nz-menu-item>
                      <a nz-button nzType="text" [routerLink]="['/product-catalog/manage-catalog', catalog.id,catalog.catalogCode]"
                        [queryParams]="{catalogName: catalog.name}" style="background: none;">
                        <span nz-icon nzType="edit" nzTheme="outline"></span> {{'Edit' | translate}}
                      </a>
                    </li>
    
                    <li nz-menu-item>
                      <a nz-button nzType="text" nzDanger nz-popconfirm
                        [nzPopconfirmTitle]="'Are you sure delete this catalog?' | locale"
                        (nzOnConfirm)="deleteCatalog(catalog.id)" style="background: none;">
                        <span nz-icon nzType="delete" nzTheme="outline"></span> {{'Delete' | translate}}
                      </a>
                    </li>

                  </ul>
                </nz-dropdown-menu>
              </ng-container>
              <ng-container *isAuthorized="'Viewer'">
                <a nz-button nzType="text">
                  <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                </a>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>


    </div>

    
  </div>
</div>